import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { Divider, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import CustomText from "../text/CustomText";
import Pagination from "../Pagination";
import { Theme } from "../../Theme";

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: ${({ $overlayColor }) => $overlayColor};
    z-index: 1000;
    display: flex;
    justify-content: ${({ side }) => (side === "right" ? "flex-end" : side === "left" ? "flex-start" : "center")};
    padding-right: ${({ side, paddingRight }) =>
        paddingRight === undefined ? (side === "right" ? "1vw" : "0") : paddingRight};
    padding-left: ${({ side, paddingLeft }) =>
        paddingLeft === undefined ? (side === "left" ? "1vw" : "0") : paddingLeft};
    box-sizing: border-box;
    align-items: ${({ alignItems }) => alignItems};
    padding-top: ${({ paddingTop }) => paddingTop || "0"};
`;

export const ModalContainer = styled.div`
    background-color: ${Theme.color.white};
    border-radius: 16px;
    border-top-left-radius: ${({ $borderTopLeftRadius }) => $borderTopLeftRadius || "16px"};
    border-bottom-left-radius: ${({ $borderBottomLeftRadius }) => $borderBottomLeftRadius || "16px"};
    box-shadow: 0 4px 12px ${Theme.color.black_015};
    width: ${({ width }) => width || "90%"};
    height: ${({ height }) => height || "auto"};
    max-width: ${({ maxWidth }) => maxWidth || "1100px"};
    max-height: ${({ maxHeight }) => maxHeight || "90vh"};
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const ModalContent = styled.div`
    flex: 1;
    overflow-y: ${({ $allowContentScroll }) => ($allowContentScroll ? "auto" : "hidden")};
    padding: ${({ padding }) => padding || "0"};
`;

const CustomModal = ({
    title,
    isOpen,
    onClose,
    children,
    width,
    side = "center",
    contentPadding = "20px 20px",
    maxWidth,
    height,
    hasPagination,
    bottomButtons,
    isCloseIfOutside = true,
    paddingRight,
    overlayColor = Theme.color.black_025,
    alignItems = "center",
    paddingTop,
    allowContentScroll = true,
    totalPage = 1,
    currentPage: currentPageProp,
    changePage,
}) => {
    // for pagination
    const [currentPage, setCurrentPage] = useState(currentPageProp ?? 1);
    const totalPages = totalPage;

    useEffect(() => {
        if (currentPageProp !== undefined) {
            setCurrentPage(currentPageProp);
        }
    }, [currentPageProp]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        changePage(page);
    };

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <ModalOverlay
            onClick={isCloseIfOutside ? onClose : () => {}}
            side={side}
            paddingRight={paddingRight}
            $overlayColor={overlayColor}
            alignItems={alignItems}
            paddingTop={paddingTop}
        >
            <ModalContainer onClick={(e) => e.stopPropagation()} width={width} height={height} maxWidth={maxWidth}>
                <Row width={"100%"} padding={"21px 27px 21px 27px"} justifyContent={"space-between"}>
                    <CustomText fontSize={"18px"} fontWeight={"700"}>
                        {title}
                    </CustomText>
                    <CustomIcon iconName={"close"} onClick={onClose} size={"24px"} cursor={"pointer"} />
                </Row>
                <Divider />
                <ModalContent padding={contentPadding} $allowContentScroll={allowContentScroll}>
                    {children}
                </ModalContent>
                {hasPagination && (
                    <>
                        <Row justifyContent={"center"} padding={"16px 0"}>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </Row>
                        <SizedBox width={"100%"} height={"16px"} />
                    </>
                )}
                {bottomButtons}
            </ModalContainer>
        </ModalOverlay>,
        document.getElementById("modal-root")
    );
};

export default CustomModal;
